"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TLSSettings = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const SelfSignedCertificate_1 = require("./SelfSignedCertificate");
const TLSClientAuth_1 = require("./TLSClientAuth");
const SkipTLSVerification_1 = require("./SkipTLSVerification");
const ConfigSection_1 = require("../../ConfigSection");
const TLSSettings = ({ selfSignedCertificate, TLSClientAuth, skipTLSVerification, readOnly }) => {
    const { spacing } = (0, ui_1.useTheme2)();
    const styles = {
        container: (0, css_1.css)({
            marginTop: spacing(3),
        }),
    };
    return (react_1.default.createElement(ConfigSection_1.ConfigSubSection, { className: styles.container, title: "TLS settings", description: "Additional security measures that can be applied on top of authentication" },
        react_1.default.createElement(SelfSignedCertificate_1.SelfSignedCertificate, Object.assign({}, selfSignedCertificate, { readOnly: readOnly })),
        react_1.default.createElement(TLSClientAuth_1.TLSClientAuth, Object.assign({}, TLSClientAuth, { readOnly: readOnly })),
        react_1.default.createElement(SkipTLSVerification_1.SkipTLSVerification, Object.assign({}, skipTLSVerification, { readOnly: readOnly }))));
};
exports.TLSSettings = TLSSettings;
//# sourceMappingURL=TLSSettings.js.map